// extracted by mini-css-extract-plugin
export var form = "_dr-0";